export function removeColorsFromHTML(text: string) {
  const pattern = /(\s*(color|background(-color)?)\s*:\s*[^;"]+;?)/gi;
  return text.replace(pattern, '').replace(/style="\s*"/g, '');
}
